export default "__VITE_PUBLIC_ASSET__e9a622f5__"